import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';

var _excluded = ["disabled", "children", "message", "state"];
var Label = /*#__PURE__*/forwardRef(function Label(props, ref) {
  var disabled = props.disabled,
      children = props.children,
      message = props.message,
      state = props.state,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var className = cn('yt-label', {
    'text-grey-dark': disabled
  }, props.className);
  var messageClassName = cn('yt-label__message', {
    'text-grey-darkest': !state || state === 'default',
    'text-red': state === 'error',
    'text-green': state === 'success',
    'text-blue': state === 'information',
    'text-yellow-dark': state === 'warning',
    'opacity-50': disabled
  }, props.className);
  return createElement("label", Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }), children, message && createElement("span", {
    className: messageClassName,
    role: state === 'error' ? 'alert' : undefined
  }, message));
});

export { Label };
//# sourceMappingURL=Label.js.map
